import { createAuthClient } from "better-auth/react";
import { env } from "./env";
import { isMock } from "./mock";

const realAuthClient = createAuthClient({
  baseURL: env.apiBase,
  basePath: "/v1/auth",
});

// Mock mode (VITE_MOCK=true) has no API to hold a session, so the UI can be
// driven end to end with a fixed signed-in user. Add `?signed-out` to the
// URL to see the signed-out screens.
const mockUser = {
  id: "mock-user",
  email: "dev@svgmascot.test",
  name: "Dev",
  image: null as string | null,
};
const day = 864e5;
let mockSessions = [
  {
    id: "mock-session",
    token: "mock-token",
    userAgent: navigator.userAgent,
    ipAddress: "127.0.0.1",
    createdAt: new Date(Date.now() - 3 * day),
    updatedAt: new Date(),
  },
  {
    id: "mock-phone",
    token: "mock-phone-token",
    userAgent:
      "Mozilla/5.0 (iPhone; CPU iPhone OS 18_0 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/18.0 Mobile/15E148 Safari/604.1",
    ipAddress: "203.0.113.7",
    createdAt: new Date(Date.now() - 20 * day),
    updatedAt: new Date(Date.now() - 2 * day),
  },
];
const ok = <T>(data: T) => ({ data, error: null });

const mockAuthClient = {
  getSession: async () =>
    ok(
      new URLSearchParams(window.location.search).has("signed-out")
        ? null
        : {
            user: mockUser,
            session: { id: "mock-session", userId: mockUser.id },
          }
    ),
  signOut: async () => ok(null),
  signIn: { social: async () => ok(null) },
  updateUser: async ({ name }: { name?: string }) => {
    if (name !== undefined) mockUser.name = name;
    return ok({ status: true });
  },
  listSessions: async () => ok(mockSessions),
  listAccounts: async () =>
    ok([
      {
        id: "mock-account",
        providerId: "github",
        accountId: "1",
        userId: mockUser.id,
        scopes: [],
        createdAt: new Date(Date.now() - 20 * day),
        updatedAt: new Date(Date.now() - 20 * day),
      },
    ]),
  revokeSession: async ({ token }: { token: string }) => {
    mockSessions = mockSessions.filter((s) => s.token !== token);
    return ok({ status: true });
  },
  revokeOtherSessions: async () => {
    mockSessions = mockSessions.filter((s) => s.id === "mock-session");
    return ok({ status: true });
  },
} as unknown as typeof realAuthClient;

export const authClient = isMock ? mockAuthClient : realAuthClient;
